import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import moment from "moment";

export const maintenanceListTodo = createAsyncThunk('maintenanceList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `maintanance`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'maintanance_type': data?.maintananceType,
                'location_id': data?.locationId,
                'block_id': data?.blockId,
                'sub_location_id': data?.subLocationId,
                'maintanance_status': data?.status,
                'start_date': data?.startDate && moment(data?.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                'end_date': data?.endDate && moment(data?.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                // 'assetDetailId': data?.assetDetailId,
                'search': data?.search,
                'sort_by': data?.sortBy,
                'sort_order': data?.sortOrder,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const maintenanceListSlice = createSlice({
    name: 'maintenanceList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(maintenanceListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(maintenanceListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default maintenanceListSlice.reducer; 